<div class="container">
  <img src="assets/not-found.svg" alt="404" />
  <div class="texts">
    <h1>Página não encontrada</h1>
    <h2>A página que você acessou não está disponível.</h2>
  </div>
  <div class="button">
    <app-botao
      text="Voltar para a página inicial"
      (click)="navigateInserirInformacoesLaudo()"
      bgColor="#FF7B01"></app-botao>
  </div>
</div>
